import {useDispatch, useSelector} from 'react-redux';
import {useHistory, useParams} from 'react-router-dom';
import React, {useEffect, useState} from 'react';
import {hasPermission} from '../../../helpers/functions';
import {PERMISSIONS} from '../../../helpers/constants';
import {useTranslation} from 'react-i18next';
import {getCompaniesClients, getCompaniesClientsList} from '../../../redux/actions/clients/clientsActions';
import {mainPath} from '../../../routes/paths';
import CompaniesHero from '../../Components/Companies/CompaniesHero';
import LoadPanel from '../../Components/LoadPanel';
import CustomerInner from '../../Components/Companies/CustomerInner';

const CompaniesCustomersSingle = () => {
  const dispatch = useDispatch();
  const {clientId} = useParams();
  const [btnLoading, setBtnLoading] = useState(false);
  const history = useHistory();

  const {profileMe} = useSelector((state) => state.profile);

  const {singleCompany} = useSelector((state) => state.company);

  const editPermission = hasPermission(PERMISSIONS.CUSTOMER_EDIT, profileMe?.permissions ?? []);
  const blockCustomerPermission = hasPermission(PERMISSIONS.CUSTOMER_BLOCK, profileMe?.permissions ?? []);
  const returnCustomerPermission = hasPermission(PERMISSIONS.CUSTOMER_RETURN, profileMe?.permissions ?? []);
  const {companiesClients, companiesClientsList, companiesClientsLoading, companiesClientsListLoading} = useSelector(
    (state) => state.clients
  );

  const {t} = useTranslation();

  useEffect(() => {
    if (companiesClientsListLoading && !companiesClientsList.length) {
      dispatch(getCompaniesClientsList(singleCompany.id));
    }
  }, [dispatch, singleCompany.id, companiesClientsLoading]);

  useEffect(() => {
    const fetch = async () => {
      dispatch(getCompaniesClients(clientId));
    };

    if (Object.keys(singleCompany).length > 0) {
      fetch();
    }
  }, [singleCompany, clientId]);

  const handleAdd = () => {
    history.push(`${mainPath.companiesCustomersAdd.replace(':id', singleCompany?.id)}`);
  };

  const handleBack = () => {
    history.push(mainPath.companiesCustomers.replace(':id', singleCompany?.id));
  };

  const addPermission = hasPermission(PERMISSIONS.PROJECT_MEMBER_ADD, profileMe?.permissions ?? []);
  const viewProjectPermission = hasPermission(PERMISSIONS.MEMBER_PROJECT_LIST, profileMe?.permissions ?? []);
  const removePermission = hasPermission(PERMISSIONS.PROJECT_MEMBER_REMOVE, profileMe?.permissions ?? []);

  return (
    <div className='companies-customers-wrapper'>
      <div className='companies-customers'>
        <div className='companies-name'>{singleCompany?.name ?? ''}</div>

        <CompaniesHero
          heading={`${companiesClientsList.length} ${t('CompaniesCustomers.clients_count')}`}
          subHeading={t('CompaniesCustomers.clients')}
          selectedBack={true}
          handleList={handleBack}
          selectedList={true}
          handleAdd={handleAdd}
          disabledActionAdd={!addPermission}
        />
        {companiesClientsLoading ? (
          <LoadPanel noBg={true} circleSize={40} staticPos={true} />
        ) : (
          <>
            <CustomerInner
              companyId={singleCompany.id}
              setBtnLoading={setBtnLoading}
              companiesClients={companiesClients}
              btnLoading={btnLoading}
              handleList={handleBack}
              editPermission={editPermission}
              project={false}
              viewProjectPermission={viewProjectPermission}
              blockCustomerPermission={blockCustomerPermission}
              returnCustomerPermission={returnCustomerPermission}
              removePermission={removePermission}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default CompaniesCustomersSingle;
